__turbopack_context__.v({
  "container": "settings-module__tIWiEq__container",
  "dangerBtn": "settings-module__tIWiEq__dangerBtn",
  "description": "settings-module__tIWiEq__description",
  "header": "settings-module__tIWiEq__header",
  "hint": "settings-module__tIWiEq__hint",
  "input": "settings-module__tIWiEq__input",
  "label": "settings-module__tIWiEq__label",
  "saveBtn": "settings-module__tIWiEq__saveBtn",
  "saveSection": "settings-module__tIWiEq__saveSection",
  "section": "settings-module__tIWiEq__section",
  "sectionTitle": "settings-module__tIWiEq__sectionTitle",
  "sectionsGrid": "settings-module__tIWiEq__sectionsGrid",
  "settingItem": "settings-module__tIWiEq__settingItem",
  "slider": "settings-module__tIWiEq__slider",
  "subtitle": "settings-module__tIWiEq__subtitle",
  "title": "settings-module__tIWiEq__title",
  "toggle": "settings-module__tIWiEq__toggle",
  "toggleRow": "settings-module__tIWiEq__toggleRow",
});
